export default __webpack_public_path__ + "static/media/2.fde01d4a.png";